module.exports = __webpack_public_path__ + "img/blue-Services-icon-2.d4196766.svg";